import { ArrayUtil, ServerError, ServerErrorType, StringUtil, handleError } from "@mcleod/core";
import { ReflectiveDialogs } from "../base/ReflectiveDialogs";
import { DataSource } from "./DataSource";

export class DataConflictErrorHandler {

    public static handleDataSourceError(error: any, failedDataSource: DataSource) {
        if (error instanceof ServerError && error.errorType === ServerErrorType.DATA_CONFLICT) {
            ReflectiveDialogs.showDataConflictError(error).then((shouldRefresh: boolean) => {
                if (!shouldRefresh) return;

                let targetDS = failedDataSource;
                // Try to find a specific child dataSource that matches the error model
                if (StringUtil.equalsIgnoreCase(failedDataSource.url, error.modelName) === false &&
                    ArrayUtil.isEmptyArray(failedDataSource.childDataSources) !== true) {

                    const candidates = failedDataSource.childDataSources.filter(c => StringUtil.equalsIgnoreCase(c.url, error.modelName));
                    if (candidates.length > 0) {
                        const match = DataConflictErrorHandler.findMatchingDataSource(candidates, error);
                        if (match)
                            targetDS = match;
                    }
                }

                if (targetDS != null && targetDS.lastSearch != null) {
                    targetDS.search(targetDS.lastSearch);
                    targetDS.notifyHasChangedComponents();
                    if (targetDS != failedDataSource) {
                        failedDataSource.notifyHasChangedComponents();
                    }
                }
            })
        } else {
            // Fallback to default handling for all other errors
            handleError(error);
        }
    }

    private static findMatchingDataSource(candidates: DataSource[], error: ServerError): DataSource | undefined {
        const { keyData, conflicts } = error.details || {};

        if (keyData && conflicts) {
            // Matching on the conflict data may not be possible if the conflict values (strings) are formatted differently
            // than the model data (Date / Currency objects).
            const match = candidates.find(ds => this.dataSourceMatches(ds, keyData, conflicts));
            if (match) return match;
        }

        // Fallback: ensure we pick a dataSource that contains the row with matching keyData
        return candidates.find(ds => this.dataSourceMatches(ds, keyData));
    }

    private static dataSourceMatches(ds: DataSource, keyData: any, conflicts?: any[]): boolean {
        if (!ds.data || ds.data.length === 0) return false;

        const keys = Object.keys(keyData);
        return ds.data.some(row => {
            let foundMatch = keys.every(key => row.get(key) == keyData[key]);

            if (foundMatch && conflicts != null) {
                foundMatch = conflicts.every(conflict => row.get(conflict.field) == conflict.attempted_value)
            }

            return foundMatch;
        });
    }
}
